import React, { useCallback, useState } from "react"
import { useHistory, useParams } from "react-router-dom"
import { gql, useMutation, useQuery } from "@apollo/client"

import { Layout } from "components"
import { Hero } from "./components"
import {
  // Analytics,
  Bookings,
  Coupons,
  Documents,
  // Itinarary,
  Passengers,
  Products,
  Settings,
} from "components/pages/Trip"

import queryString from "query-string"

const TRIP = gql`
  query Trip($id: ID!) {
    trip(id: $id) {
      id
      name
      url
      slug
      code
      startDate
      endDate
      destinations
      status
      image {
        id
        name
        url
      }

      products {
        id
      }
    }
  }
`

const UPDATE_TRIP_STATUS = gql`
  mutation UpdateTripStatus($input: UpdateTripStatusInput!) {
    updateTripStatus(input: $input) {
      id
      status
    }
  }
`

const DELETE_TRIP = gql`
  mutation DeleteTrip($id: ID!) {
    deleteTrip(id: $id)
  }
`

const Trip = () => {
  const history = useHistory()
  const query = queryString.parse(history.location.search)

  const { id } = useParams()

  const params = { variables: { id } }
  const { data, loading, error } = useQuery(TRIP, params)
  const trip = (data && data.trip) || {}

  const [updateTripStatus] = useMutation(UPDATE_TRIP_STATUS)

  const handleStatusChange = async (status) => {
    if (
      window.confirm(`Are you sure you want to change status to ${status}?`)
    ) {
      await updateTripStatus({
        variables: { input: { id, status } },
        update(cache, { data }) {
          const existing = cache.readQuery({ query: TRIP, variables: { id } })

          const changed = data?.updateTripStatus

          cache.writeQuery({
            query: TRIP,
            variables: { id },
            data: {
              trip: {
                ...existing?.trip,
                status: changed.status,
              },
            },
          })
        },
      })
    }
  }

  const [deleteTrip] = useMutation(DELETE_TRIP)

  const handleTripDelete = useCallback(async () => {
    try {
      await deleteTrip({ variables: { id } })

      history.push("/groups")
    } catch (e) {
      console.error(e)
    }
  })

  const [selectedTab, setSelectedTab] = useState(
    Number(query.tab ? query.tab : 0),
  )

  const handleTabSelect = (index) => {
    history.push({
      pathname: window.location.pathname,
      search: "?" + new URLSearchParams({ tab: index }).toString(),
    })

    setSelectedTab(index)
  }

  const tabs = [
    // "Analytics",
    "Bookings",
    "Coupons",
    "Documents",
    // "Itinarary",
    "Passengers",
    "Products",
    "Settings",
  ]

  const tabContainers = [
    // <Analytics tripId={id} />,
    <Bookings tripId={id} />,
    <Coupons tripId={id} />,
    <Documents tripId={id} />,
    // <Itinarary tripId={id} />,
    <Passengers tripId={id} />,
    <Products tripId={id} />,
    <Settings tripId={id} />,
  ]

  const ActiveTab = () => tabContainers[selectedTab]

  const getHeroProps = () => {
    return {
      ...trip,
      isPublishable: trip?.products?.length > 0 ? true : false,
      updateTripStatus: handleStatusChange,
      onDelete: handleTripDelete,
    }
  }

  return (
    <Layout title={trip?.name} isLoading={loading}>
      <main className="w-full min-h-screen flex flex-col">
        <Hero {...getHeroProps(trip)}>
          <ul className="flex mt-2">
            {tabs.map((tab, index) => (
              <li key={index} className="mr-3">
                <button
                  onClick={() => handleTabSelect(index)}
                  className={`inline-block rounded py-1 px-3 text-gray-200 ${
                    index === selectedTab && "bg-indigo-500 text-white"
                  } hover:bg-indigo-300 hover:text-white`}
                >
                  {tab}
                </button>
              </li>
            ))}
          </ul>
        </Hero>

        <div className="flex-1">
          <main className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8 pb-32">
            <div className="relative -mt-20 z-30">
              <ActiveTab />
            </div>
          </main>
        </div>
      </main>
    </Layout>
  )
}

Trip.propTypes = {}

export default Trip
